(function ($) {
  "use strict";

  // サーバ側から渡されるID配列を取得
  function getSalaryTypeIds() {
    var $hourlyWrapper = $('#desired-hourly-salary-wrapper');
    var hourlyTypes = [];

    try {
      hourlyTypes = JSON.parse($hourlyWrapper.attr('data-hourly-salary-types') || '[]');
    } catch (e) {
      // パースエラー時は空配列のまま
    }

    return {
      hourly: hourlyTypes
    };
  }

  function getCheckedEmploymentTypes() {
    var checkedTypes = [];
    $('[name^="profile_desired_job"]').each(function() {
      if ($(this).is(':checked')) {
        var typeId = parseInt($(this).val());
        if (!isNaN(typeId)) {
          checkedTypes.push(typeId);
        }
      }
    });
    return checkedTypes;
  }

  function updateSalaryVisibility() {
    var checkedTypes = getCheckedEmploymentTypes();
    var salaryTypeIds = getSalaryTypeIds();

    var showHourly = checkedTypes.some(function(type) {
      return salaryTypeIds.hourly.indexOf(type) !== -1;
    });

    if (showHourly) {
      $('#desired-hourly-salary-wrapper').show();
    } else {
      $('#desired-hourly-salary-wrapper').hide();
      $('#edit-profile-desired-hourly-salary').val('');
    }
  }

  $(document).ready(function() {
    // 初期表示時に状態を更新
    updateSalaryVisibility();

    // 希望雇用形態のチェック状態が変わった時に更新
    $('[name^="profile_desired_job"]').on('change', updateSalaryVisibility);
  });
})(jQuery);
